import { PaddleUserLocation, UserStatus } from "../../../index";

interface UserProps {
	id: string;
	email: string;
	username: string;
	status: UserStatus;
	statusMessage?: string;
	paddleUserId?: string;
	paddleUserLocation?: PaddleUserLocation;
	licenseKey?: string;
	createdAt: Date;
	legacyUser: boolean;
	cannyToken?: string;
}

class User {
	constructor(public _: UserProps) {}

	static fromFirestore = (doc: any): User => {
		const data = doc.data();
		return new User({
			id: doc.id,
			email: data.email,
			username: data.username,
			status: data.status || UserStatus.ACTIVE,
			statusMessage: data.status_message,
			paddleUserId: data.paddle_user_id,
			licenseKey: data.license_key,
			createdAt: data.created_at?.toDate(),
			paddleUserLocation: data.paddle_user_location
				? PaddleUserLocation.fromJson(data.paddle_user_location)
				: undefined,
			legacyUser: data.legacy_user,
			cannyToken: data.canny_token,
		});
	};
}

export { User };
